module.exports = __webpack_public_path__ + "img/manWithFlag.15c4a072.png";